// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Panel__grid {
  display: grid;
  gap: 16px;
}
.n-Panel__grid--columns-1 {
  grid-template-columns: 1fr;
}
.n-Panel__grid--columns-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.n-Panel__grid--columns-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.n-Panel__grid--columns-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.n-Panel__grid--columns-auto {
  grid-template-columns: repeat(auto-fit, minmax(var(--n-panel-grid-min-column-width, 140px), 1fr));
}
.n-Panel__grid--equal-height-items > * {
  height: 100%;
}
@media (max-width: 760px) {
  .n-Panel__grid--columns-2,
  .n-Panel__grid--columns-3,
  .n-Panel__grid--columns-4 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/panel/PanelGrid.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,aAAA;EACA,SAAA;AAQJ;AANI;EACE,0BAAA;AAQN;AALI;EACE,gDAAA;AAON;AAJI;EACE,gDAAA;AAMN;AAHI;EACE,gDAAA;AAKN;AAFI;EACE,iGAAA;AAIN;AAEI;EACE,YAAA;AAAN;AAKA;EAEI;;;IAGE,0BAAA;EAJJ;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-Panel {\n  &__grid {\n    display: grid;\n    gap: @layoutUnit-md;\n\n    &--columns-1 {\n      grid-template-columns: 1fr;\n    }\n\n    &--columns-2 {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    &--columns-3 {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n\n    &--columns-4 {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n\n    &--columns-auto {\n      grid-template-columns: repeat(\n        auto-fit,\n        minmax(var(--n-panel-grid-min-column-width, 140px), 1fr)\n      );\n    }\n\n    &--equal-height-items > * {\n      height: 100%;\n    }\n  }\n}\n\n@media (max-width: 760px) {\n  .n-Panel {\n    &__grid--columns-2,\n    &__grid--columns-3,\n    &__grid--columns-4 {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
